/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_Empty_FreshInputs */

const vi_my_weighings_empty_fresh = /** @type {(inputs: My_Weighings_Empty_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có phiếu cân chè tươi nào trong khoảng đã chọn.`)
};

/**

* @param {My_Weighings_Empty_FreshInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_empty_fresh = /** @type {((inputs?: My_Weighings_Empty_FreshInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_Empty_FreshInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_empty_fresh(inputs)
});